import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/V1/userRequestController";
import moment from "moment";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import UserSelectWithSearch from "../../../components/UserSelectWithSearch";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () =>  togglePopUp();
  const [bind_person_id, setBindPersonId] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  const handleExport = async (e) => {
    e.preventDefault(0);
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);

      const fromDate = formData.get('from_date');
      const toDate = formData.get('to_date');
      
      // Build date condition
      let dateCondition = {};
      if (fromDate && toDate) {
        dateCondition.createdAt = {
          $gte: new Date(`${fromDate} 00:00:00`),
          $lte: new Date(`${toDate} 23:59:59`)
        };
      } else if (fromDate) {
        dateCondition.createdAt = {
          $gte: new Date(`${fromDate} 00:00:00`)
        };
      } else if (toDate) {
        dateCondition.createdAt = {
          $lte: new Date(`${toDate} 23:59:59`)
        };
      }

      const option = {
        condition : { 
          ...dateCondition,
          ...(formData.get('first_name') && {first_name : formData.get('first_name')}),
          ...(formData.get('last_name') && {last_name : formData.get('last_name')}),
          ...(formData.get('email') && {email : formData.get('email')}),
          ...(formData.get('mobile') && {mobile : parseInt(formData.get('mobile'))}),
          ...(formData.get('area') && {area : parseInt(formData.get('area'))}),
          ...(formData.get('status') && {status : formData.get('status')}),
          ...((bind_person_id && bind_person_id?.length > 0) && { bind_person_id : { $in : bind_person_id} })
         }
      }
      
      const res = await list(option);
      if(res.status === true){
        let modifiedData = res?.result.map((items, index) => ({
          "Sl. No"                  : index + 1,
          "First Name"              : items?.first_name,
          "Last Name"               : items?.last_name,
          "Mobile No."              : `${items?.country_code} ${items?.mobile}`,
          "Email Address"           : items?.email,
          "Area"                    : items?.area,
          "Store Name"              : items?.store_name,
          "Bind With Person"        : items?.bind_person_id?.users_name,
          "Bind With Person Type"   : items?.bind_person_id?.users_type,
          "Status"                  : items?.status,
          "Remarks"                 : items?.remarks,
          "Created At"              : moment(items?.createdAt).format('DD-MM-YYYY HH:mm'),
          "Updated At"              : moment(items?.updatedAt).format('DD-MM-YYYY HH:mm')
        }));
        if(modifiedData?.length > 0){
          await exportToExcel(modifiedData);
        }
        handleCancel();
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Request list");
      XLSX.writeFile(workbook, `Users-Request-List-${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }

  };

  const handleBindWith = (value) => {
    try {
      setBindPersonId(value);
    } catch (error) {
      
    }
  }
  
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Export Request List
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleExport}>
                  <div className="form-group row">

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label htmlFor="select_bind_with" className="all_section_for_label_main_class" >
                        Select Bind With :
                      </label>
                      <UserSelectWithSearch
                        value={bind_person_id}
                        onChange={(value) => handleBindWith(value)}
                        placeholder="Select bind with users"
                        className="form-control store_input_field"
                        style={{ width: '100%' }}
                        disableOptions={false}
                      />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="first_name" className="all_lable_for_vendor_dashbaord" > First Name :</label>
                      <input type="text" name="first_name" id="first_name" placeholder="Enter first name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="last_name" className="all_lable_for_vendor_dashbaord" > Last Name :</label>
                      <input type="text" name="last_name" id="last_name" placeholder="Enter last name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="email" className="all_lable_for_vendor_dashbaord" > Email Address :</label>
                      <input type="text" name="email" id="email" placeholder="Enter email address" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="mobile" className="all_lable_for_vendor_dashbaord" > Mobile Number :</label>
                      <input type="number" name="mobile" id="mobile" placeholder="Enter mobile number" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="area" className="all_lable_for_vendor_dashbaord" > Area :</label>
                      <input type="text" name="area" id="area" placeholder="Enter area" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="status" className="all_lable_for_vendor_dashbaord" > Status :</label>
                      <select name="status" id="status" class="form-control categories_select_tg_enter_product">
                        <option value={""}>Select status</option>
                        <option value={"Pending"}>Pending</option>
                        <option value={"Completed"}>Completed</option>
                        <option value={"Rejected"}>Rejected</option>
                      </select>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="from_date" className="all_lable_for_vendor_dashbaord" > From Date : <span style={{color: 'red'}}>*</span></label>
                      <input type="date" name="from_date" id="from_date" required class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="to_date" className="all_lable_for_vendor_dashbaord" > To Date : <span style={{color: 'red'}}>*</span></label>
                      <input type="date" name="to_date" id="to_date" required class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button type="submit" className="btn btn-danger" > Download Excel </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
